import React from 'react';
import { connect } from 'react-redux';

import { WheelContainer } from './WheelContainer/WheelContainer';

import './Gauges.scss';
import { storeGaugesNotifications } from '../../store/Gauges/actions/storeGaugesNotifications';
import { getGaugesNotifications } from '../../store/Gauges/actions/getGaugesNotifications';
import { MapGaugesNotifications } from '../../../services/GaugesNotificationService';
import { ProductTypes } from '../../constants/ProductTypes';
import { ActiveProduct } from '../../../models/ActiveProduct';
import { getAcceptedProducts } from './gaugesHelper';
interface SGGaugesProps {
    activeProducts: ActiveProduct[];
    gaugesNotifications: MapGaugesNotifications;
    storeGaugesNotifications: typeof storeGaugesNotifications;
    getGaugesNotifications: typeof getGaugesNotifications;
}

export class Gauges extends React.Component<SGGaugesProps, any> {
    private filteredAcceptedProducts: ActiveProduct[];
    private GAUGES_HIDDEN = 'gauges__hidden';
    private GAUGES_CONTAINER = 'gauges__container';

    constructor(props: SGGaugesProps) {
        super(props);

        this.state = {
            globalState: null,
            ready: false,
            pendingNotificationsType: [],
        };
        this.filteredAcceptedProducts = [];
    }

    componentWillMount() {
        if (this.props.activeProducts && this.props.activeProducts.length) {
            this.setState({ ready: true });
        }
    }

    componentDidUpdate({
        activeProducts: prevActiveProducts,
        gaugesNotifications: prevGaugesNotifications,
    }: SGGaugesProps) {
        const { getGaugesNotifications, gaugesNotifications, activeProducts } = this.props;

        const hasChangedActiveProducts = prevActiveProducts !== activeProducts;
        const hasChangedGaugesNotification = prevGaugesNotifications !== gaugesNotifications;

        if (hasChangedActiveProducts) {
            this.setState({ ready: true });
            getGaugesNotifications(activeProducts);
        }

        if (hasChangedGaugesNotification) {
            const pendingNotificationsType = this.getPendingNotificationsTypes(activeProducts, gaugesNotifications);

            this.setState({ pendingNotificationsType });
        }
    }

    private getPendingNotificationsTypes(
        activeProducts: ActiveProduct[],
        gaugesNotifications: MapGaugesNotifications
    ): ProductTypes[] {
        let pendingNotificationsType: ProductTypes[] = [];

        for (let productIndex = 0; productIndex < activeProducts.length; ++productIndex) {
            const product = activeProducts[productIndex];
            const productNotification = gaugesNotifications.has(product.type)
                ? gaugesNotifications.get(product.type)
                : undefined;
            const hasPendingNotifications = productNotification && productNotification.pendingNotification;

            if (hasPendingNotifications) {
                pendingNotificationsType.push(product.type);
            }
        }

        return pendingNotificationsType;
    }

    private filterAcceptedProducts(): void {
        this.filteredAcceptedProducts = getAcceptedProducts(this.props.activeProducts);
    }

    private onGaugeClosed(type: ProductTypes) {
        const { storeGaugesNotifications, gaugesNotifications } = this.props;
        const gaugesNotification = gaugesNotifications.get(type);

        if (gaugesNotification) {
            gaugesNotification.closeNotification();

            storeGaugesNotifications(gaugesNotification, this.filteredAcceptedProducts);
        }
    }

    private renderWheels = () => {
        this.filterAcceptedProducts();

        return this.filteredAcceptedProducts.map((prod: ActiveProduct, index: number) => {
            const { pendingNotificationsType } = this.state;

            const isFirstNotification = pendingNotificationsType.indexOf(prod.type) === 0;
            const hasPeriod = prod.currentPeriod && prod.currentPeriod.to;

            return (
                <WheelContainer
                    id={prod.id}
                    type={prod.type}
                    totCredits={prod.quantity}
                    usedCredits={prod.usedCredits}
                    period={prod.period}
                    periodEndingDate={hasPeriod}
                    key={index}
                    forceClickToHide={isFirstNotification}
                    onCloseModal={() => this.onGaugeClosed(prod.type)}
                />
            );
        });
    };

    render() {
        const { ready } = this.state;
        const activeProductsReady = this.props.activeProducts && this.props.activeProducts.length !== 0;
        const classes = !ready ? `${this.GAUGES_HIDDEN} ${this.GAUGES_CONTAINER}` : this.GAUGES_CONTAINER;

        if (!activeProductsReady) {
            return <div></div>;
        }

        return <div className={classes}>{this.renderWheels()}</div>;
    }
}

const mapStateToProps = (state: any) => {
    return {
        activeProducts: state.products.activeProducts,
        gaugesNotifications: state.gauges.gaugesNotifications,
    };
};

export default connect(mapStateToProps, {
    getGaugesNotifications,
    storeGaugesNotifications,
})(Gauges);
